// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Formality from "../../../../../../../node_modules/re-formality/src/Formality.bs.js";
import * as Caml_format from "../../../../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as WorkSpaceContext from "../../../../../../library/work-space/WorkSpaceContext.bs.js";
import * as FormInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as FormHelper$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as Formality__ReactUpdate from "../../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.bs.js";
import * as FormSelectInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormSelectInput.bs.js";
import * as FormRadioGroupInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormRadioGroupInput.bs.js";

function getGeoRegionOptions(geoRegions) {
  return List.map((function (region) {
                return {
                        key: String(region.id),
                        value: String(region.id),
                        text: region.name
                      };
              }), geoRegions);
}

function CorePricingFilterSection$GeoRegionSelection(Props) {
  var selected_geo_region = Props.selected_geo_region;
  var geo_region_options = Props.geo_region_options;
  var update_geo_region = Props.update_geo_region;
  var result = Props.result;
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "label"
                }, "GEOLOCATION"), React.createElement(FormSelectInput$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("", Curry.__1(update_geo_region), undefined, undefined, undefined, undefined, undefined, undefined, result, undefined, "geo-region-filter", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  select_props: {
                    value: selected_geo_region,
                    items: geo_region_options,
                    isNoneRequired: false
                  }
                }));
}

var GeoRegionSelection = {
  getGeoRegionOptions: getGeoRegionOptions,
  make: CorePricingFilterSection$GeoRegionSelection
};

function getVehicleTypesRadioOptions(vehicle_types) {
  return List.map((function (vehicle) {
                return {
                        label: vehicle.vehicle.vehicle_type,
                        value: String(vehicle.vehicle_id)
                      };
              }), vehicle_types);
}

function CorePricingFilterSection$VehicleTypeSelection(Props) {
  var selected_vehicle_type = Props.selected_vehicle_type;
  var update_vehicle_type = Props.update_vehicle_type;
  var vehicle_types = Props.vehicle_types;
  var result = Props.result;
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "label"
                }, "VEHICLES"), React.createElement(FormRadioGroupInput$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("", Curry.__1(update_vehicle_type), undefined, undefined, undefined, undefined, undefined, undefined, result, undefined, "vehicle-filter", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  radio_props: {
                    options: getVehicleTypesRadioOptions(vehicle_types),
                    value: selected_vehicle_type,
                    row_layout: false
                  }
                }));
}

var VehicleTypeSelection = {
  getVehicleTypesRadioOptions: getVehicleTypesRadioOptions,
  make: CorePricingFilterSection$VehicleTypeSelection
};

var validators = {
  vehicle_type: undefined,
  geo_region: undefined
};

function initialFieldsStatuses(_input) {
  return {
          vehicle_type: /* Pristine */0,
          geo_region: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            vehicle_type: /* Pristine */0,
            geo_region: /* Pristine */0
          },
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, param, param$1) {
  var match_0 = {
    TAG: /* Ok */0,
    _0: input.vehicle_type
  };
  var match_0$1 = {
    TAG: /* Ok */0,
    _0: input.geo_region
  };
  var vehicle_typeResult = match_0;
  var vehicle_typeResult$1;
  if (vehicle_typeResult.TAG === /* Ok */0) {
    var geo_regionResult = match_0$1;
    if (geo_regionResult.TAG === /* Ok */0) {
      return {
              TAG: /* Valid */0,
              output: {
                geo_region: geo_regionResult._0,
                vehicle_type: vehicle_typeResult._0
              },
              fieldsStatuses: {
                vehicle_type: /* Dirty */{
                  _0: vehicle_typeResult,
                  _1: /* Hidden */1
                },
                geo_region: /* Dirty */{
                  _0: geo_regionResult,
                  _1: /* Hidden */1
                }
              },
              collectionsStatuses: undefined
            };
    }
    vehicle_typeResult$1 = vehicle_typeResult;
  } else {
    vehicle_typeResult$1 = vehicle_typeResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            vehicle_type: /* Dirty */{
              _0: vehicle_typeResult$1,
              _1: /* Hidden */1
            },
            geo_region: /* Dirty */{
              _0: match_0$1,
              _1: /* Hidden */1
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurVehicle_typeField */0 :
                  var result = Formality.validateFieldOnBlurWithoutValidator(state.input.vehicle_type, state.fieldsStatuses.vehicle_type, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  vehicle_type: status,
                                  geo_region: init.geo_region
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurGeo_regionField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithoutValidator(state.input.geo_region, state.fieldsStatuses.geo_region, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  vehicle_type: init.vehicle_type,
                                  geo_region: status
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */2 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */2,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */3,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */5);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */4);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */3 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */4 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */5 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateVehicle_typeField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput.vehicle_type, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            vehicle_type: status,
                                            geo_region: init.geo_region
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateGeo_regionField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$1.geo_region, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            vehicle_type: init.vehicle_type,
                                            geo_region: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */2 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                vehicle_type: /* Pristine */0,
                                geo_region: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                vehicle_type: /* Pristine */0,
                                geo_region: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */3 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */4 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateVehicle_type: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateVehicle_typeField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateGeo_region: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateGeo_regionField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurVehicle_type: (function (param) {
              return Curry._1(dispatch, /* BlurVehicle_typeField */0);
            }),
          blurGeo_region: (function (param) {
              return Curry._1(dispatch, /* BlurGeo_regionField */1);
            }),
          vehicle_typeResult: Formality.exposeFieldResult(state.fieldsStatuses.vehicle_type),
          geo_regionResult: Formality.exposeFieldResult(state.fieldsStatuses.geo_region),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.vehicle_type || match.geo_region) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */2);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */3);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */4);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */4,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */5);
            })
        };
}

var FilterForm = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function CorePricingFilterSection(Props) {
  var geo_regions = Props.geo_regions;
  var selected_geo_region = Props.selected_geo_region;
  var vehicle_types = Props.vehicle_types;
  var selected_vehicle_type = Props.selected_vehicle_type;
  var changeVehicleSelection = Props.changeVehicleSelection;
  var workspaceDispatch = WorkSpaceContext.useWorkSpace(undefined);
  var geo_region_options = getGeoRegionOptions(geo_regions);
  var form = useForm({
        geo_region: FormSelectInput$Catalyst.SelectUtils.getSelectedItemByValue(String(selected_geo_region), geo_region_options),
        vehicle_type: String(selected_vehicle_type)
      }, (function (param, param$1) {
          
        }));
  React.useEffect((function () {
          var geoRegion = form.input.geo_region;
          if (geoRegion !== undefined) {
            Curry._1(workspaceDispatch.replaceTab, {
                  TAG: /* PricingDashboard */44,
                  geo_region_id: Caml_format.caml_int_of_string(geoRegion.value)
                });
          }
          
        }), [form.input.geo_region]);
  React.useEffect((function () {
          Curry._1(changeVehicleSelection, Caml_format.caml_int_of_string(form.input.vehicle_type));
          
        }), [form.input.vehicle_type]);
  return React.createElement("div", {
              className: "filter-section"
            }, React.createElement(CorePricingFilterSection$GeoRegionSelection, {
                  selected_geo_region: form.input.geo_region,
                  geo_region_options: geo_region_options,
                  update_geo_region: (function ($$event) {
                      return Curry._2(form.updateGeo_region, (function (input, value) {
                                    return {
                                            geo_region: value,
                                            vehicle_type: input.vehicle_type
                                          };
                                  }), FormSelectInput$Catalyst.SelectUtils.getSelectedItemByValue(FormHelper$Catalyst.TargetEventWrapper.value($$event), geo_region_options));
                    }),
                  result: form.geo_regionResult
                }), React.createElement(CorePricingFilterSection$VehicleTypeSelection, {
                  selected_vehicle_type: form.input.vehicle_type,
                  update_vehicle_type: (function ($$event) {
                      return Curry._2(form.updateVehicle_type, (function (input, value) {
                                    return {
                                            geo_region: input.geo_region,
                                            vehicle_type: value
                                          };
                                  }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                    }),
                  vehicle_types: vehicle_types,
                  result: form.vehicle_typeResult
                }));
}

var make = CorePricingFilterSection;

export {
  GeoRegionSelection ,
  VehicleTypeSelection ,
  FilterForm ,
  make ,
  
}
/* react Not a pure module */
